import { defineStore } from 'pinia';
import { useApi } from '@lib/api';
import { useGlobalStore } from '@/store/global-store-base';

export const useSkuCodes = defineStore('sku-codes', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.skuCode_GetSkuCodes,
    dto: 'SkuCodeDto',
    create: api.skuCode_CreateSkuCode,
    update: api.skuCode_UpdateSkuCode,
    delete: api.skuCode_DeleteSkuCode,
    signalR: 'SkuCodeUpdate',
  });

  return {
    ...globalStoreBase,
  };
});
